import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { CompanyDetailResponse } from '@/repositories/generated';

const response: CompanyDetailResponse = {
  id: '00001',
  externalCompanyId: 'company01',
  name: '株式会社〇〇〇〇',
  status: 'AVAILABLE',
  phone: '03-1234-5678',
  companyDetailBasicInfo: {
    postalCode: '102-0083',
    prefecture: '東京都',
    municipalities: '千代田区麹町5-7-2',
    acquirerId: 12,
    acquirerName: 'アクワイアラA',
    startDate: '2023/09/27',
    endDate: '2030/09/27',
    terminalOptionalNarrowedFlg: true,
    createdAt: '2022/09/24 18:51',
    updatedAt: '2022/09/24 18:51',
    externalIdUpdateAvailableFlg: true,
  },
  companyDetailQrInfo: {
    corporationId: '1234567890123',
    brandId: '4567',
  },
  companyDetailBankAccountAndCycleInfo: {
    bankCode: '0001',
    bankBranchCode: '001',
    bankAccountType: 'DEPOSIT_ACCOUNT',
    bankAccountNumber: '1234567',
    bankAccountName: 'ｶ)ｲﾝﾌｷﾕﾘｵﾝ',
    clearingCycle: 'DAILY',
  },
  remarks: 'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト',
  regex: '^[^\x00-\x1F\x7Fｦ-ﾟ]+$',
  companyDetailSmartCodeInfo: {
    nameKana: 'テストキギョウ',
    nameRomaji: 'TESUTOKIGYOU',
    merchantCategoryCode: '00001',
    smartCodeStartsAt: '2023-01-01T00:00:00+09:00',
    smartCodeEndsAt: '2100-12-31T00:00:00+09:00',
  },
};

export const companyDetail = http.get(
  createMockEndpoint('/company/:id'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
